import React from 'react';

const LOGO_SOURCES = {
  vertical: '/dr_logo_new_vertical.png',
  horizontal: '/dr_logo_new_horizontal.png',
};

const Logo = ({ variant = 'vertical', className = '', alt = 'DataRook Logo' }) => {
  const src = LOGO_SOURCES[variant];

  if (!src) {
    return null;
  }

  return (
    <img
      src={src}
      alt={alt}
      width={variant === 'horizontal' ? 160 : 96}
      height={variant === 'horizontal' ? 48 : 96}
      className={`h-8 md:h-12 w-auto object-contain ${className}`.trim()}
    />
  );
};

export default Logo;
